import DegreesModel from '../Apis/Degrees.js'
import Controller from './Controller.js';

export default class DegreesController extends Controller {

    constructor() {
        super(new DegreesModel());
    }


}
